import {connect, useSelector} from "react-redux";
import React, {Fragment} from "react";
import {Box} from "@mui/material";
import _ from "lodash";
import moment from "moment";
import DateRangeFilter from "../../../common/DateRangeFilter";
import {reduxForm} from "redux-form";
import ActionButton from "../../../common/ActionButton";
import useLocationQueryParams from "../../../hooks/useLocationQueryParams";
import {getYearRange, queryStringToObject} from "_helpers";
import BasicFilterSelect from "../../../common/BasicFilterSelect";
import useGetActiveOrganizations from "./hooks/useGetActiveOrganizations";
import LoadingPlaceholderBlock from "../../../../common/LoadingPlaceholderBlock";
import { RETAIN_CAMPAIGNS, ACQUIRE_CAMPAIGNS } from "../../RetainDashboard/Utilities/CampaignUtils";

const CAMPAIGN_TYPES = [
    {id: RETAIN_CAMPAIGNS, name: 'Retain'},
    {id: ACQUIRE_CAMPAIGNS, name: 'Acquire'}
]

function GetCampaignForm({
    handleSubmit,
    organizationId,
    pageFilter,
    setOrganizationId,
    setPageFilter,
    startDate,
    endDate,
    setDates,
    onSubmit,
}) {
    const { setParams } = useLocationQueryParams();
    const { loadingAcquireCampaign } = useSelector(state => state.acquire);
    const { loadingRetainCampaign } = useSelector(state => state.retain);
    const { organizations, loading: organizationLoading } = useGetActiveOrganizations();

    const yearCount = 2;

    const dateRange = {
        startDate,
        endDate,
    };

    const organizationName = organizations?.find((item) => item.id === organizationId)
    const campaignType = CAMPAIGN_TYPES.find((item) => item.id === pageFilter) || CAMPAIGN_TYPES[0];

    const handleDateRangeChange = (startDate, endDate) => {
        const dateParam = {
            ...dateRange,
            startDate: moment(startDate).startOf('day').toISOString(),
            endDate: moment(endDate).endOf('day').toISOString()
        }
        setDates({
            startDate,
            endDate,
        });
        setParams(dateParam);
    }

    const handleOrganizationSelectChange = (event) => {
        setOrganizationId(event?.id)
        setParams({ organizationId: event?.id });
    }

    const handleCampaignTypeChange = (event) => {
        setPageFilter(event?.id)
        setParams({ pageFilter: event?.id });
    }

    return(
        <Fragment>
            <form name="form" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <Box sx={styles.paramSelectionContainer}>
                    <Box sx={styles.campaignSelectContainer}>
                        <BasicFilterSelect
                            placeholder={'Select campaign type'}
                            options={CAMPAIGN_TYPES}
                            value={campaignType}
                            onChange={handleCampaignTypeChange}
                            textFieldStyle={styles.organizationSelectInput}
                            listBoxHeight={380}
                            isClearable={true}
                        />
                    </Box>
                    <DateRangeFilter
                        name="dateRange"
                        startDate={startDate}
                        endDate={endDate}
                        handleChange={handleDateRangeChange}
                        additionalRanges={[
                            getYearRange(yearCount)
                        ]}
                    />
                    <Box sx={styles.organizationSelectContainer}>
                        {organizationLoading ?
                            <LoadingPlaceholderBlock
                                width={'100%'}
                                height={'45px'}
                                borderRadius={'8px'}
                                backgroundColor={'#E3E2E1'}
                            /> :
                            <BasicFilterSelect
                                placeholder={'Select organization'}
                                options={organizations}
                                value={organizationName}
                                onChange={handleOrganizationSelectChange}
                                textFieldStyle={styles.organizationSelectInput}
                                listBoxHeight={380}
                            />
                        }
                    </Box>
                    <Box sx={styles.applyButtonContainer}>
                        <ActionButton
                            label={'Apply'}
                            disabled={loadingAcquireCampaign || loadingRetainCampaign}
                            sx={{width: '110px'}}
                        />
                    </Box>
                </Box>
            </form>
        </Fragment>
    )
}

function validate(values) {
    const errors = {};
    const {organizationId} = values;
    if(_.isEmpty(_.toString(organizationId)) || organizationId === 'none') errors.organizationId = 'invalid organization';
    return errors;
}

const formConfig = {
    form: 'GetCampaignForm',
    validate
};

GetCampaignForm = reduxForm(formConfig)(GetCampaignForm)
GetCampaignForm = connect( function (state) {
    const search = window.location.search.substring(1);
    const queryObj =  queryStringToObject(search);

    return {
        initialValues: {
            organizationId: _.get(queryObj, 'organizationId'),
        }
    }
})(GetCampaignForm);
export default GetCampaignForm;

const styles = {
    paramSelectionContainer: {
        width: { xs: '100%', sm: 'auto' },
        display: 'flex',
    },
    campaignSelectContainer: {
        width: '150px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        mr: '10px'
    },
    organizationSelectContainer: {
        width: '250px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        ml: '10px'
    },
    organizationSelectInput : {
        [`& fieldset`]: {
            borderRadius: '8px',
        },
        '& .MuiInputBase-input': {
            height: '12px',
        },
    },
    applyButtonContainer: {
        display: 'flex',
        alignItems: 'center',
        pt: '2px',
        ml: '10px'
    }
}